import { asDate } from "@@/shared/date-time/as-date";
import { getLocale } from "@@/shared/date-time/locales";
import type { LanguageCode } from "@@/shared/translations/language-code";
import type { IsoAndUnixTimestamp } from "../../shared/date-time/iso-and-unix";

const getNameOfMonth = (
    date: IsoAndUnixTimestamp | Date,
    type: "short" | "long" = "long",
    language: LanguageCode = "sv",
    timeZone = "Europe/Stockholm",
) => {
    const locale = getLocale(language);
    const formatter = new Intl.DateTimeFormat(locale.code, {
        month: type,
        timeZone,
    });
    return formatter.format(asDate(date));
};
const getNameOfMonthAndYear = (
    date: IsoAndUnixTimestamp | Date,
    type: "short" | "long" = "long",
    locale = "sv-SE",
    timeZone = "Europe/Stockholm",
) => {
    const formatter = new Intl.DateTimeFormat(locale, {
        month: type,
        year: "numeric",
        timeZone,
    });
    return formatter.format(asDate(date));
};
const getYear = (
    date: IsoAndUnixTimestamp | Date,
    locale = "sv-SE",
    timeZone = "Europe/Stockholm",
) => {
    const formatter = new Intl.DateTimeFormat(locale, {
        year: "numeric",
        timeZone,
    });
    return formatter.format(asDate(date));
};

export { getNameOfMonth, getNameOfMonthAndYear, getYear };
